import axiosInstance from './axiosInstance';

export const GetOpenSOListByStore = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/saleOrder/openlist/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllSalesByStoreID = async (store_id, est_sale) => {
  try {
    const { data } = await axiosInstance.get(`/saleOrder/TypeStoreId/${est_sale}/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllPurchaseByCompStorID = async (company_id, store_id) => {
  try {
    const { data } = await axiosInstance.get(`/purchaseorder/CompanyIdStoreId/${company_id}/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetReceivePartsByPoID = async (po_id) => {
  try {
    const { data } = await axiosInstance.get(`/receivelog/Data/${po_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetReceiveLogDetailByid = async (po_id) => {
  try {
    const { data } = await axiosInstance.get(`/receivelog/View/${po_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSalesOrderDataByID = async (so_id) => {
  try {
    const { data } = await axiosInstance.get(`/saleorder/Data/${so_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSalesOrderPartsByID = async (so_id) => {
  try {
    const { data } = await axiosInstance.get(`/saleorder/Parts/${so_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPurchaseOrderDataByID = async (po_id) => {
  try {
    const { data } = await axiosInstance.get(`/purchaseorder/Data/${po_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPurchaseOrderPartsByID = async (po_id) => {
  try {
    const { data } = await axiosInstance.get(`/purchaseorder/Parts/${po_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddSalesOrderFileApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/SaleOrder/File`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const DeleteSalesOrderFileApi = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/saleOrder/filedel/${id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddSalesOrderApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/SaleOrder`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddPurchaseOrderApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/purchaseorder`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const ConvertQuoteApi = async (so_id, formData) => {
  try {
    const { data } = await axiosInstance.put(`/saleorder/convert/${so_id}`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditSalesOrderApi = async (so_id, formData) => {
  try {
    const { data } = await axiosInstance.put(`/saleorder/${so_id}`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditPurchaseOrderAPi = async (po_id, formData) => {
  try {
    const { data } = await axiosInstance.put(`/purchaseorder/${[po_id]}`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const CloseSalesOrderApi = async (so_id) => {
  try {
    const { data } = await axiosInstance.put(`/saleorder/closestatus/${so_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const ClosePurchaseOrderAPi = async (po_id) => {
  try {
    const { data } = await axiosInstance.put(`/purchaseorder/closestatus/${[po_id]}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const TransferSalesOrderApi = async (so_id, store_id) => {
  try {
    const { data } = await axiosInstance.put(`/saleorder/TransferStore/${so_id}/${store_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const TransferPurchaseOrderAPi = async (po_id, store_id) => {
  try {
    const { data } = await axiosInstance.put(`/purchaseorder/TransferStore/${po_id}/${store_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const DeleteQuoteApi = async (so_id) => {
  try {
    const { data } = await axiosInstance.delete(`/saleOrder/${so_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditReceive_Log = async (po_id, user_id, logs) => {
  try {
    const { data } = await axiosInstance.post(`/ReceiveLog`, { po_id: po_id, user_id: user_id, logs: logs });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const GetAllSaleOrderNotes = async () => {
  try {
    const { data } = await axiosInstance.get(`/saleordernote/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddSaleOrderNote = async (title, note) => {
  try {
    const { data } = await axiosInstance.post(`/saleordernote`, { title: title, notes: note });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditSaleOrderNote = async (id, title, note) => {
  try {
    const { data } = await axiosInstance.put(`/saleordernote/${id}`, { title: title, notes: note });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
